import _get from 'lodash/get';
import { camelize } from '@ember/string';
import { compare } from '@ember/utils';

export default function sortCollection(collection, sortParam) {
  if (!sortParam) return collection;

  const sortParams = sortParam.split(',');
  let sortedCollection = collection;

  // Sort from the furthest-out value first; this is because we want the final result to be sorted primarily
  // by the first-named value, with the others used to determine sorted for identical values. Because JS sort
  // is stable (yay ECMAScript 2019) we can get away with this.
  for (let sort of sortParams.reverse()) {
    let sortDirection = 1; // 1 for ascending, -1 for descending
    if (sort.startsWith('-')) {
      sortDirection = -1;
      sort = sort.substring(1);
    }
    // Convert dasherized values (which are passed as `sort` values) to camelCase (which is how Mirage names attributes/relationships).
    sort = camelize(sort);

    // Use _get() to handle nesting in names (e.g., `location.name`, `employee.user.fullName`, etc.)
    sortedCollection = sortedCollection.sort((a, b) => sortDirection * compare(_get(a, sort), _get(b, sort)));
  }
  return sortedCollection;
}
